import React, { useState } from 'react';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../shadcn/ui/table';
import Constants from '@/constants';
import { EditIcon, Trash2Icon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '../shadcn/ui/button';
import { da } from 'date-fns/locale';
import { useBusinessDetailContext } from '@/context/BusinessDetailContext';
import DeleteBusinessDialog from './DeleteBusinessDialog';

interface LeadFormData {
  id: number;
  description: string;
  status: string | null;
  closedAt: string | null;
  startedAt: string | null;
  prevision: string | null;
  contactNumber: string | null;
  observation: string | null;
  value: number | null;
  companyId: number;
  clientId: number | null;
  situation:string;
  createdById: number;
  opportunityFlowId: number;
  activityTypes: {
    name: string ;
  } | null;
  opportunityFlow: {
    description: string
  } | null;
  client: {
    fantasyName: string
  } | null;
}

type TableViewProps ={
    data: LeadFormData[];
    onLeadDelete: (index: number) => void;
}

// const {}

const TableView: React.FC<TableViewProps> = ({ data, onLeadDelete }) => {
  const {business, fetchbusinessById, deleteOpen, setDeleteOpen} = useBusinessDetailContext();
  const [index, setIndex] = useState<number>(0);
  return (  
    <div className='m-4 rounded-md sm:border'>
      <Button onClick={()=>{console.log(data);}}>Teste</Button>
      <Table>
        <TableHeader>
          <TableRow>
            {Constants.LISTA_COLUNAS_NEGOCIOS.map((coluna) => (
              <TableHead className='h-10' key={coluna}>{coluna}</TableHead>
            ))}
            <TableHead colSpan={2}>Ações</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {data.map((negocio, index) => (
            <TableRow key={index}>
              <TableCell>{negocio.id}</TableCell>
              <TableCell>{negocio.description}</TableCell>
              <TableCell>{negocio.contactNumber}</TableCell>
              <TableCell>{negocio.opportunityFlow ? negocio.opportunityFlow.description : null}</TableCell>
              <TableCell>{negocio.startedAt}</TableCell>
              <TableCell>{negocio.prevision}</TableCell>
              <TableCell>{negocio.closedAt}</TableCell>
              <TableCell>{negocio.status}</TableCell>
              <TableCell>{negocio.value}</TableCell>
              <TableCell>{negocio.observation}</TableCell>
              <TableCell>
                <div className='flex gap-2 items-baseline'>
                  <button title='Apagar'>
                    <Trash2Icon onClick={() => {
                      setIndex(index);
                      setDeleteOpen(true);
                    }} size={26} className='bg-red-600 hover:bg-red-800 rounded-md p-1'/>
                  </button>
                  <Link to={`/detalhe/${negocio.id}`}>
                    <button title='Editar'>
                      <EditIcon size={26} className='bg-lime-600 hover:bg-lime-800 rounded-md p-1'
                      />
                    </button>
                  </Link>
                </div>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <DeleteBusinessDialog handleDelete={()=>{onLeadDelete(index);}}/>
    </div>
  );
};

export default TableView;
